import React from 'react'
import styles from './styles.module.css'
import { Textarea } from '../../../components/ModalInputs'

const Literature = ({ lessonData, handleLessonDataChange }) => {
    return (
        <div className={styles.literatureWrapper}>
            <Textarea
                label='Список литературы'
                className={styles.textareaWrapper}
                textareaClassName={styles.textarea}
                value={lessonData?.literature || ''}
                onChange={(e) => handleLessonDataChange('literature', e.target.value)}
            />
        </div>
    )
}

export default Literature
